import type { IResponse } from '../types';

export async function fetchGet<T>(url: string, options: any = {}): Promise<IResponse<T> | null> {
  try {
    const response = await fetch(url, { ...options });

    if (!response.ok || response.status >= 400) {
      throw new Error('Server responds with error!');
    }

    return await response.json();
  } catch (e) {
    console.error((e as Error).message);
    throw new Error('ServerError');
  }
}
